@if (!isAdmin) {
  <div
    class="group fixed right-0 bottom-[10%] text-gray-700 border border-border shadow-xl text-md p-2 hover:p-4 rounded-l-lg transition-all duration-75 hover:w-80 w-44 bg-yellow-500 overflow-hidden max-h-28 items-center"
    style="z-index: 5000">
    <div class="flex space-x-2 w-full">
      <div class="w-full grid grid-cols-3 text-xxs group-hover:text-xs">
        <div class="group-hover:hidden col-span-3 font-semibold uppercase tracking-widest">
          <div class="inline-flex">
            <img class="" src="/assets/streamlinehq-user-question.SVG" />
            <p class="text-center">Get in touch with us!</p>
          </div>
        </div>
        <div class="hidden group-hover:block col-span-3 overflow-hidden items-center content-center mb-2">
          <a class="inline-flex w-full h-full" [href]="'mailto:' + brand.contactEmail">
            <span class="w-8 h-full content-center"><img src="/assets/streamlinehq-mail.SVG" /></span>
            <span class="ml-2 underline content-center">{{ brand.contactEmail }}</span></a
          >
        </div>

        <div class="hidden group-hover:block col-span-3 overflow-hidden items-center content-center">
          <div class="inline-flex w-full h-full">
            <span class="w-8 h-full content-center"> <img src="assets/streamlinehq-mobile-phone.SVG" /></span>
            <span class="ml-2 content-center"> +49 40 309 293-52</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
